import React from 'react';
import { isSubtitleDebugEnabled } from '../utils/subtitleDebug';

const SubtitleDebugOverlay = ({
  contentId,
  subtitleUrl,
  subtitleUrlsProp,
  fetchedSubtitleUrls,
  mergedSubtitleUrls,
  selectedLang,
  subtitlesEnabled,
  loadingLang,
  subtitleError,
  textTrackCount = 0,
  apiStats = {},
}) => {
  if (!isSubtitleDebugEnabled()) return null;

  const activeUrl = mergedSubtitleUrls?.[selectedLang] || null;

  return (
    <div className="absolute top-14 left-3 z-[60] max-w-xs rounded-lg border border-yellow-400/40 bg-black/85 p-2 text-[10px] leading-snug text-yellow-100 font-mono pointer-events-none">
      <div className="font-bold text-yellow-300 mb-1">CC DEBUG</div>
      <div>contentId: {contentId || '—'}</div>
      <div>enabled: {String(subtitlesEnabled)}</div>
      <div>lang: {selectedLang}</div>
      <div>tracks: {textTrackCount}</div>
      <div>loading: {loadingLang || '—'}</div>
      <div className="truncate" title={activeUrl || ''}>
        url: {activeUrl ? activeUrl.slice(-48) : '—'}
      </div>
      <div>merged langs: {Object.keys(mergedSubtitleUrls || {}).join(', ') || '—'}</div>
      <div>prop url: {subtitleUrl ? 'yes' : 'no'}</div>
      <div>prop urls: {subtitleUrlsProp ? Object.keys(subtitleUrlsProp).length : 0}</div>
      <div>fetched langs: {Object.keys(fetchedSubtitleUrls || {}).join(', ') || '—'}</div>
      <div>
        API load: {apiStats.loadCount ?? 0} | generate: {apiStats.generateCount ?? 0}
      </div>
      {subtitleError ? <div className="text-red-300">err: {subtitleError}</div> : null}
    </div>
  );
};

export default SubtitleDebugOverlay;
